export const BASE_URL = process.env.REACT_APP_BASEAPI_URL;
export const API_V5 = process.env.REACT_APP_API_V5 ?? "v5/";
export const API_V51 = process.env.REACT_APP_API_V51 ?? "v5.1/";
export const API_V6 = process.env.REACT_APP_API_V6 ?? "v6/";
export const DEFAULT_API_VERSION =
  process.env.REACT_APP_DEFAULT_API_VERSION ?? API_V5;
export const SCHEDULE_API_VERSION =
  process.env.REACT_APP_SCHEDULE_API_VERSION ?? API_V51;
export const MCP_API_VERSION =
  process.env.REACT_APP_MCP_API_VERSION ?? API_V6;

// LoginAPI Endpoints
export const GetLoginById_url = `${DEFAULT_API_VERSION}ReactLogin_api`;
export const GetLoginByIdPassword_url = `${DEFAULT_API_VERSION}User/validation`;
export const ManualLogin_url = `${DEFAULT_API_VERSION}User/login`;
export const RedirectToUrl = `${DEFAULT_API_VERSION}User/selectLgnRegMethod`;
export const Register_url = `${DEFAULT_API_VERSION}User/register`;
export const ForgotPassword_url = `${DEFAULT_API_VERSION}User/forgotPassword`;
export const ResetPassword_url = `${DEFAULT_API_VERSION}User/resetPassword`;
export const validateResetPasswordToken_url = `${DEFAULT_API_VERSION}User/validateResetPasswordToken`;
export const validateRegisterConfirmation_url = `${DEFAULT_API_VERSION}User/verifyUser`;
export const originMismatch_url = `${DEFAULT_API_VERSION}access_denied/origin_mismatch`;
export const CheckUserVehicle_url = `${DEFAULT_API_VERSION}CheckUserVehicle_api`;

export const UserLogout_url = `${DEFAULT_API_VERSION}UserLogout_api`;
// Token API Endpoint
export const GetRefreshToken_api = `${DEFAULT_API_VERSION}Token_api`;

// Weekly-Calendar API Endpoints
export const GetWeeklyCalendar_url = `${API_V6}MyWeeklyBookings_api`;
export const ZoneList_url = `${DEFAULT_API_VERSION}ZoneList_api`;
export const MakeBooking_url = `${SCHEDULE_API_VERSION}MakeBooking_api`;
export const CancelBooking_url = `${DEFAULT_API_VERSION}CancelBooking_api`;
export const MapGrid_api = `${API_V6}MapGrid_api`;
export const MapCanvas_api = `${API_V6}MapCanvas_api`;
export const GetParticipantsForMeeting_url = `${DEFAULT_API_VERSION}MeetingRoom_api/GetParticipantsForMeeting`;
export const RescheduleMeeting_url = `${DEFAULT_API_VERSION}MeetingRoom_api/RescheduleMeeting`;
export const MeetingRoomListAndInfo_url = `${DEFAULT_API_VERSION}MeetingRoom_api/MeetingRoomListAndInfo`;
export const CreateNewMeeting_url = `${DEFAULT_API_VERSION}MeetingRoom_api/CreateNewMeeting`;
export const EditMeeting_url = `${SCHEDULE_API_VERSION}EditMeeting_api`;
export const ReportParkingViolation_url = `${API_V6}ReportParkingViolation_api`;
export const GetAlternateParkingSpot_url = `${API_V6}GetAlternateParkingSpot_api`;
export const CancelMeeting_url = `${DEFAULT_API_VERSION}MeetingRoom_api/CancelMeeting`;
export const DeclineMeeting_url = `${DEFAULT_API_VERSION}MeetingRoom_api/DeclineMeeting`;

// Notification API Endpoints
export const NotificationList_url = `${DEFAULT_API_VERSION}NotificationList_api`;
export const NotificationToggleStatus_url = `${DEFAULT_API_VERSION}NotificationToggleStatus_api`;
export const CheckInUser_url = `${DEFAULT_API_VERSION}CheckInUser_api`;
export const MarkAsReadNotification_url = `${DEFAULT_API_VERSION}MarkAsReadNotification_api`;
export const BookingConfirmation_url = `${DEFAULT_API_VERSION}BookingConfirmation_api`;
export const ScheduledBookingConfirmation_url = `${DEFAULT_API_VERSION}ScheduledBookingConfirmation_api`;
export const BookingStatus_url = `${DEFAULT_API_VERSION}MakeBooking_api/BookingStatus`;

// Post-Booking Question API Endpoints
export const PostBookingQuestion_url = `${DEFAULT_API_VERSION}PostBookingQuestion_api`;
export const PostBookingAnswer_url = `${DEFAULT_API_VERSION}PostBookingAnswer_api`;
export const MapBasedBooking_apiBookingStatus_url = `${SCHEDULE_API_VERSION}MapBasedBooking_api/BookingStatus`;

// Home > My Bookings API Endpoints
export const HomeScreenBookings_url = `${DEFAULT_API_VERSION}HomeScreenBookings_api`;
export const SearchBookings_url = `${DEFAULT_API_VERSION}SearchBookings_api`;

// Home > My Inviatations API Endpoints
export const InvitationGuestBookings_url = `${DEFAULT_API_VERSION}InvitationGuestBookings_api`;
export const CheckInForGuestUser_url = `${DEFAULT_API_VERSION}CheckInForGuestUser_api`;
export const ReportParkingViolationForGuest_url = `${API_V6}ReportParkingViolationForGuest_api`;
export const GetAlternateParkingSpotForGuest_url = `${API_V6}GetAlternateParkingSpotForGuest_api`;

// Create New Booking API Endpoints
export const QuickBookingInfo_url = `${DEFAULT_API_VERSION}QuickBookingInfo_api`;
export const SpotAvailability_url = `${DEFAULT_API_VERSION}SpotAvailability_api`;
export const MapBasedBooking_url = `${DEFAULT_API_VERSION}MapBasedBooking_api`;

// Profile API Endpoints
export const Profile_url = `${DEFAULT_API_VERSION}Profile_api`;

// Setting > Need help? API Endpoints
export const Support_url = `${DEFAULT_API_VERSION}Support_api`;

// Setting > Remove account API Endpoint
export const RemoveAccount_url = `${DEFAULT_API_VERSION}User/removeAccount`;
